import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { invalidateAfterPlayContent } from './invalidateAfterPlayContent';
import { usePlayContentOnScreen } from './usePlayContentOnScreen';

type UsePlayContentFlowArgs = {
  organisationId: string;
  screenId: string;
  startOpen?: boolean;
  onPlayed?: (playlistName: string) => void;
};

/**
 * Open/close + one-tap play for Manage — picker opens in the Content column.
 */
export function usePlayContentFlow({
  organisationId,
  screenId,
  startOpen = false,
  onPlayed,
}: UsePlayContentFlowArgs) {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(startOpen);

  const play = usePlayContentOnScreen({
    organisationId,
    screenId,
    enabled: open,
    onPlayed: (playlistName) => {
      setOpen(false);
      invalidateAfterPlayContent(queryClient, organisationId, screenId);
      onPlayed?.(playlistName);
    },
  });

  return {
    open,
    openPicker: () => setOpen(true),
    closePicker: () => {
      if (!play.playPending) setOpen(false);
    },
    ...play,
  };
}
